import { AddIcon } from '@approvalmax/ui';
import { Button, Flex, Select, Text } from '@approvalmax/ui/src/components';
import { useActiveCompany } from 'modules/common';
import { useSelector } from 'modules/react-redux';
import { FC, memo } from 'react';
import { HelpStripe } from 'shared/components';

import { getReportType } from '../../selectors/pageSelectors';
import { useReportCreation, useReportsSorting } from './ReportsListToolbar.hooks';
import { messages } from './ReportsListToolbar.messages';
import { ReportsListToolbarProps } from './ReportsListToolbar.types';

export const ReportsListToolbar: FC<ReportsListToolbarProps> = memo((props) => {
    const { helpStripeId } = props;

    const company = useActiveCompany();
    const reportType = useSelector(getReportType);

    const onReportCreateClick = useReportCreation(company, reportType);
    const { sortingOptions, activeSortingOption, setActiveSortingOptionId } = useReportsSorting();

    return (
        <Flex container alignItems='center' justifyContent='space-between' wrap={false} data-qa='reports-list-toolbar'>
            <Flex size={8}>
                <Button onClick={onReportCreateClick} color='blue10' size='small' startIcon={<AddIcon />}>
                    {messages.buttonNewReport}
                </Button>
            </Flex>

            <Flex size={16} spacing='12' alignItems='center' justifyContent='end'>
                <HelpStripe.ToggleButton id={helpStripeId} />

                <Flex alignItems='center' spacing='4' data-qa='reports-list-toolbar-filter'>
                    <Text font='body' fontSize='medium'>
                        {messages.sortingLabel}
                    </Text>

                    <Select
                        noInput
                        items={sortingOptions}
                        value={activeSortingOption?.id}
                        onChange={setActiveSortingOptionId}
                        dropdownWidth='max-content'
                    />
                </Flex>
            </Flex>
        </Flex>
    );
});

ReportsListToolbar.displayName = 'ReportsListToolbar';
